import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { useAppContext } from 'app/AppContext';
import DataTable from 'components/DataTable';
import { fetchArray } from 'entity';
import Grupo from 'entity/Grupo';

import { Box, CircularProgress, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function GrupoForm() {
    const navigate = useNavigate();
    const { useSetTitle, setActionsView } = useAppContext();
    const [options, setOptions] = useState([]);
    const EntityClass = Grupo
    const [searchNomeGrupo, setSearchNomeGrupo] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/grupo");
                },
            },

        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [navigate, setActionsView]);

    useSetTitle("GRUPOS");

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (options.length === 0) {
            let result = await fetchArray(EntityClass.getAll());

            result = result.map(g => {
                g.nome = g.nome?.toUpperCase()
                return g
            })

            setOptions(["", ...result]);
            setFilteredOptions(["", ...result]);
            setLoading(false)
        }
    }, [EntityClass, options.length]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    const onChangeSearchNomeGrupo = e => {
        setSearchNomeGrupo(e.target.value)
    }

    const handleSearch = () => {
        setFilteredOptions(
            options.filter(grupo => {
                let nome;
                if (grupo.nome?.toUpperCase().includes(searchNomeGrupo.toUpperCase())) {
                    nome = true;
                }
                return nome;
            })
        )
    }


    return (

        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <Box sx={{ textAlign: "center", mt: 0 }}>

                <Accordion sx={{ boxShadow: 3, mb: 1 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>FILTRO</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            sx={{ width: "100%" }}
                            id="nomeGrupoTextField"
                            label="NOME DO GRUPO"
                            variant="standard"
                            onChange={onChangeSearchNomeGrupo}
                            value={searchNomeGrupo}
                            onKeyUp={() => handleSearch()}
                            inputProps={{ style: { textTransform: "uppercase" } }}
                        />
                    </AccordionDetails>
                </Accordion>
            </Box>

            <DataTable
                columns={EntityClass.searchColumns}
                rows={filteredOptions}
                onRowClick={row => navigate("/grupo?uid=" + row.id)}
                components={{
                    LoadingOverlay: CircularProgress,
                }}
                loading={loading}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            />
        </Box>
    )
}